import { BaseModel } from "sjs-base-model";
import AssicurazioneModel from "stores/simulazione/models/AssicurazioneModel";

export default class CercaDettalgioSimulazioneModel extends BaseModel {
    public readonly idSimulation: number = 0;
    public readonly id: number = 0;
    public readonly name: string = "";
    public readonly date: string = "";
    public readonly effectiveDate: string = "";
    public readonly hiringDate: string = "";
    public readonly birthDate: string = "";
    public readonly amount: number = 0;
    public readonly payment: number = 0;
    public readonly duration: number = 0;
    public readonly tan: number = 0;
    public readonly teg: number = 0;
    public readonly taeg: number = 0;
    public readonly irr: number = 0;
    public readonly idProduct: number = 0;
    public readonly idRequestedType: number = 0;
    public readonly idChannel: number = 0;
    public readonly idSegment: number = 0;
    public readonly idAdministrativeCategory: number = 0;
    public readonly idAdministration?: number = undefined;
    public readonly unregisteredAtcName?: string;
    public readonly idAgent: number = 0;
    public readonly commissions: number = 0;
    public readonly balance: number = 0;
    public readonly salary: number = 0;
    public readonly requestType: string | undefined = undefined;
    public readonly administrativeCategory: string | undefined = undefined;
    public readonly agent: string | undefined = undefined;
    public readonly atc: string | undefined = undefined;
    public readonly channel: string | undefined = undefined;
    public readonly segment: string | undefined = undefined;
    public readonly product: string | undefined = undefined;
    public readonly rv: string | undefined = undefined;
    public readonly rc: string | undefined = undefined;
    public readonly insurances: AssicurazioneModel | undefined = undefined;
    constructor(data: Partial<CercaDettalgioSimulazioneModel>) {
        super();

        this.update(data);
    }
}
